import { createNullableContext } from '~/common/contexts/nullableContext';
import { AppModule } from './constants/AppModule';

export const ModuleScopeContext = createNullableContext<AppModule>();
